// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1jovM","sendOtp":"AuthorizeToLogin_sendOtp__3jqfV"};